export default __webpack_public_path__ + "static/media/academyLogo.a25545c5.svg";